import React, { useState, useEffect } from "react";
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, 
  TextField, TablePagination, Box, Typography, IconButton 
} from "@mui/material";
import { Visibility, Delete } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInstance";
import { toast } from "react-toastify";

const apiUrl = process.env.REACT_APP_API_URL;

const VendorListPage = () => {
  const [vendors, setVendors] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchVendors();
  }, [page, rowsPerPage, search]);

  const fetchVendors = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get(`${apiUrl}/vendor/list`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page: page + 1, limit: rowsPerPage, search: search },
      });

      setVendors(response.data.vendors);
      setTotalRows(response.data.total);
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleViewVendor = (id) => {
    navigate(`/vendor/${id}`);
  };

  const handleDeleteVendor = async (id) => {
    if (!window.confirm("Are you sure you want to delete this vendor?")) return;

    try {
      const token = localStorage.getItem("authToken");
      await axiosInstance.delete(`${apiUrl}/vendor/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Vendor deleted successfully!");
      fetchVendors(); // Refresh list
    } catch (error) {
      toast.error("Failed to delete vendor");
      console.error("Error deleting vendor:", error);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Vendor List
      </Typography>

      {/* Search Input */}
      <TextField
        label="Search Vendor"
        variant="outlined"
        fullWidth
        margin="normal"
        value={search}
        onChange={handleSearchChange}
      />

      {/* Vendor Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Username</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Vendor ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell> {/* Actions Column */}
            </TableRow>
          </TableHead>
          <TableBody>
            {vendors.length > 0 ? (
              vendors.map((vendor) => (
                <TableRow key={vendor.id}>
                
                  <TableCell>{vendor.username}</TableCell>
                  <TableCell>{vendor.email}</TableCell>
                  <TableCell>{vendor.vendorId || "N/A"}</TableCell>
                  <TableCell>
                    {/* View Button */}
                    <IconButton color="primary" onClick={() => handleViewVendor(vendor.id)}>
                      <Visibility />
                    </IconButton>

                    {/* Delete Button */}
                    <IconButton color="error" onClick={() => handleDeleteVendor(vendor.id)}>
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No vendors found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalRows}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default VendorListPage;
